export default __webpack_public_path__ + "static/media/illustration-study-2-n-m.575dc806.webp";